import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';
import API from '@/lib/API';
import { AssignmentType } from '@/types';
import { IntegrationsState, INTEGRATIONS_DISABLED } from '@/config/urls';

@Module
export default class Config extends VuexModule {
  // State
  assignmentTypes: AssignmentType[] = []

  // Integrazioni esterne: si parte da tutto spento, cosi' i punti d'ingresso
  // non compaiono nell'attesa della risposta del backend.
  integrations: IntegrationsState = { ...INTEGRATIONS_DISABLED }

  // Getters
  get getAssignmentTypes(): AssignmentType[] {
    return this.assignmentTypes;
  }

  get getIntegrations(): IntegrationsState {
    return this.integrations;
  }

  get isIntegrationEnabled() {
    return (nome: keyof IntegrationsState): boolean => !!this.integrations[nome]?.enabled;
  }

  get getAssignmentType() {
    return (id: string): AssignmentType | undefined => this.assignmentTypes.find((t) => t.id === id);
  }

  // Mutations
  @Mutation
  setAssignmentTypes(types: AssignmentType[]) {
    this.assignmentTypes = types;
  }

  @Mutation
  setIntegrations(integrations: IntegrationsState) {
    this.integrations = integrations;
  }

  // Actions
  @Action({ rawError: true })
  async fetchAssignmentTypes() {
    const response = await API.getAssignmentTypes();
    if (response && response.assignmentTypes) {
      this.context.commit('setAssignmentTypes', response.assignmentTypes);
    }
  }

  @Action({ rawError: true })
  async fetchIntegrations() {
    const response = await API.getIntegrations();
    if (response && response.integrations) {
      this.context.commit('setIntegrations', { ...INTEGRATIONS_DISABLED, ...response.integrations });
    }
  }
}
